import { ContentLayout, Header } from '@cloudscape-design/components';

export function BasePage() {
  return (
    <ContentLayout
      header={<Header variant="h1">Service Dashboard</Header>}
    ></ContentLayout>
  );
}
